import React from "react";
import { Link } from "react-router-dom"; // Link bileşenini React Router'dan içe aktarın
import faqData from "../../api/faqdata"; // faqData.js dosyasını içe aktarıyoruz
import { formatPage } from "../../utils/formatPage";
import { useTranslation } from "react-i18next";
const FaqCategory = () => {
  const { t } = useTranslation();
  return (
    <>
      {faqData.map((item, index) => {
        const totalItems = faqData.length;
        const isLastItemInRow =
          index === totalItems - 1 ||
          (index === totalItems - 2 && totalItems % 2 === 0);
        const isOddItem = index % 2 === 0; // Tekli satırlarda olan öğeleri kontrol ediyoruz (0, 2, 4, 6, ...)

        return (
          <div
            key={index}
            className={`col-lg-6 col-md-6 col-sm-12 col-6  p-4 pb-5 pt-5 bg-white d-flex flex-column align-items-center justify-content-center ${
              !isLastItemInRow ? "border-bottom" : ""
            } ${isOddItem ? "border-end" : ""}`} // Eğer tekli öğe ise, border-end ekle
          >
            <img
              src={item.imgSrc}
              alt={item.text}
              width={40}
              className="mb-2"
            />
            <Link
              to={`/${formatPage(item.text)}`} // URL'yi formatPage ile oluşturuyoruz
              className="fw-light fw-14 text-dark mt-2"
            >
              {t(item.textKey)}
            </Link>
          </div>
        );
      })}
    </>
  );
};

export default FaqCategory;
